export default __webpack_public_path__ + "static/media/mun.ea8d5253.jpg";